if (!window.customElements.get("nutrition-table")) {
  class NutritionTable extends HTMLElement {
    constructor() {
      super();
      this.tableData = null;
    }
  
    connectedCallback() {
      this.init();
    }
  
    init() {
      const rawData = this.getAttribute('data-table');
      if (!rawData) {
        console.error('data-table attribute is missing or empty');
        return;
      }
  
      try {
        this.tableData = JSON.parse(rawData);
        this.renderTables();
      } catch (error) {
        console.error(error);
      }
    }
  
    createTableRow(values) {
      const tr = document.createElement('tr');
      values.forEach(value => {
        const td = document.createElement('td');
        td.textContent = value;
        tr.appendChild(td);
      });
      return tr;
    }
  
    createTableHead(table) {
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
  
      for (const col in this.tableData) {
        const th = document.createElement('th');
        th.textContent = this.tableData[col].title;
        headerRow.appendChild(th);
      }
  
      thead.appendChild(headerRow);
      table.appendChild(thead);
    }
  
    createTableBody(table) {
      const tbody = document.createElement('tbody');
      const dataValues = Object.keys(this.tableData).map(col => this.tableData[col].values);
  
      for (let i = 0; i < dataValues[0].length; i++) {
        const rowData = dataValues.map(column => column[i]);
        const row = this.createTableRow(rowData);
        tbody.appendChild(row);
      }
  
      table.appendChild(tbody);
    }
  
    renderTables() {
      const table = document.createElement('table');
      this.createTableHead(table);
      this.createTableBody(table);
      this.appendChild(table);
    }
  }
  
  customElements.define('nutrition-table', NutritionTable);
}